// src/components/SearchBarContainer/SearchBarContainer.js
import React, { useState, useEffect } from "react";
import Search from "../../Assets/Images/CommanImages/searchyellow.png";
import StudentLogo from "../../Assets/Images/CommanImages/studentforsearch.png";
import { FULL_API_BASE_URL } from "../../Config/Config";

const SearchBarContainer = ({ onSelectStudentID }) => {
  const [searchKey, setSearchKey] = useState("");
  const [searchResults, setSearchResults] = useState([]);
  const [isDropdownVisible, setIsDropdownVisible] = useState(false);

  useEffect(() => {
    const handleSearch = async () => {
      if (searchKey && searchKey.length >= 3) {
        try {
          const response = await fetch(
            `${FULL_API_BASE_URL}/get-student-by-search-key/?search_key=${searchKey}`,
            {
              method: "GET",
              headers: {
                accept: "application/json",
              },
            }
          );
          const data = await response.json();
          setSearchResults(data);
        } catch (error) {
          console.error(error);
        }
      } else {
        setSearchResults([]); // Clear the search results when searchKey is empty
      }
    };

    handleSearch();
  }, [searchKey]);

  const handleStudentSelect = (studentFullName, studentID) => {
    // setSearchKey(studentFullName); // Set the search key to the selected student's name
    setSearchKey("");
    setIsDropdownVisible(false);
    onSelectStudentID(studentID);
  };

  // const handleStudentSelect = (studentFullName, rollNumber) => {
  //   // setSearchKey(studentFullName); // Set the search key to the selected student's name
  //   setSearchKey(rollNumber);
  //   setIsDropdownVisible(false);
  //   onSelectStudentID(rollNumber);
  // };

  return (
    <div className="searchbar-container">
      <input
        type="text"
        placeholder="Type here to search"
        name="search"
        className="searchbar-landing"
        value={searchKey}
        onChange={(e) => setSearchKey(e.target.value)}
        onFocus={() => setIsDropdownVisible(true)}
        onBlur={() => setTimeout(() => setIsDropdownVisible(false), 200)}
      />
      <img src={Search} className="searchbar-img-landing" alt="addition" />
      {isDropdownVisible && searchResults.length > 0 && (
        <div className="search-results-dropdown">
          {searchResults.map((result, index) => (
            <div
              key={index}
              className="search-result-item"
              onClick={() =>
                handleStudentSelect(result.student_full_name, result.student_id)
              }
            >
              <p className="first-item-student">
                <img
                  src={StudentLogo}
                  style={{ height: "25px", width: "25px", marginRight: "4px" }}
                  alt=""
                />
                {result.student_full_name}
              </p>
              <p style={{ marginTop: "5px" }} className="second-item-student">
                Batch: {result.batch_name}
              </p>
              <p className="second-item-student">
                Roll No: {result.roll_number}
              </p>
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default SearchBarContainer;
